/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Live_Caption_Display_TabInputs */

const en_live_caption_display_tab = /** @type {(inputs: Live_Caption_Display_TabInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Display`)
};

const fr_live_caption_display_tab = /** @type {(inputs: Live_Caption_Display_TabInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Afficher`)
};

const de_live_caption_display_tab = /** @type {(inputs: Live_Caption_Display_TabInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Anzeige`)
};

const it_live_caption_display_tab = /** @type {(inputs: Live_Caption_Display_TabInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Display`)
};

const ru_live_caption_display_tab = /** @type {(inputs: Live_Caption_Display_TabInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Отображать`)
};

const es_live_caption_display_tab = /** @type {(inputs: Live_Caption_Display_TabInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mostrar`)
};

const zh_cn2_live_caption_display_tab = /** @type {(inputs: Live_Caption_Display_TabInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`展示`)
};

const ja_live_caption_display_tab = /** @type {(inputs: Live_Caption_Display_TabInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`画面`)
};

const hi_live_caption_display_tab = /** @type {(inputs: Live_Caption_Display_TabInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`प्रदर्शन`)
};

const pt_pt2_live_caption_display_tab = /** @type {(inputs: Live_Caption_Display_TabInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mostrar`)
};

/**
* | output |
* | --- |
* | "Display" |
*
* @param {Live_Caption_Display_TabInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const live_caption_display_tab = /** @type {((inputs?: Live_Caption_Display_TabInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Live_Caption_Display_TabInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_live_caption_display_tab(inputs)
	if (locale === "de") return de_live_caption_display_tab(inputs)
	if (locale === "it") return it_live_caption_display_tab(inputs)
	if (locale === "ru") return ru_live_caption_display_tab(inputs)
	if (locale === "es") return es_live_caption_display_tab(inputs)
	if (locale === "zh-CN") return zh_cn2_live_caption_display_tab(inputs)
	if (locale === "ja") return ja_live_caption_display_tab(inputs)
	if (locale === "hi") return hi_live_caption_display_tab(inputs)
	if (locale === "pt-PT") return pt_pt2_live_caption_display_tab(inputs)
	return en_live_caption_display_tab(inputs)
});